const poolAddress = 
{
    bscTest :'0xbb3ECDcB5dF7118D8ef4732bE0cFB81B1c6a53a9',
    bsc: '0xee5a18e00702257B979640eCDca708F64573A598',
}

export default poolAddress;